import { unref as r } from "vue";
function u(n) {
  return r(n) != null;
}
function a(n, t) {
  if (typeof Symbol < "u") {
    const e = { ...n };
    return Object.defineProperty(e, Symbol.iterator, {
      enumerable: !1,
      value() {
        let o = 0;
        return {
          next: () => ({
            value: t[o++],
            done: o > t.length
          })
        };
      }
    }), e;
  } else
    return Object.assign([...t], n);
}
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
function c(n) {
  const t = /* @__PURE__ */ Object.create(null);
  return (e) => t[e] || (t[e] = n(e));
}
const l = /-(\w)/g, f = c((n) => n.replace(l, (t, e) => e ? e.toUpperCase() : ""));
export {
  f as camelize,
  u as isDefined,
  a as makeDestructurable
};
